import styles from "./TimeSlotSelector.module.css";

interface TimeSlotSelectorProps {
	availableSlots: string[];
	selectedSlot: string | null;
	onSelectSlot: (slot: string) => void;
}

export function TimeSlotSelector({
	availableSlots,
	selectedSlot,
	onSelectSlot,
}: TimeSlotSelectorProps) {
	// Group slots by morning, afternoon, evening
	const groupedSlots = {
		morning: availableSlots.filter((slot) => {
			const hour = Number.parseInt(slot.split(":")[0], 10);
			return hour < 12;
		}),
		afternoon: availableSlots.filter((slot) => {
			const hour = Number.parseInt(slot.split(":")[0], 10);
			return hour >= 12 && hour < 17;
		}),
		evening: availableSlots.filter((slot) => {
			const hour = Number.parseInt(slot.split(":")[0], 10);
			return hour >= 17;
		}),
	};

	const formatTime = (time: string) => {
		const [hour, minute] = time.split(":");
		const hourNum = Number.parseInt(hour, 10);
		const ampm = hourNum >= 12 ? "PM" : "AM";
		const displayHour =
			hourNum > 12 ? hourNum - 12 : hourNum === 0 ? 12 : hourNum;
		return `${displayHour}:${minute} ${ampm}`;
	};

	if (availableSlots.length === 0) {
		return (
			<div className={styles.emptyState}>
				<div className={styles.clockIcon}>🕐</div>
				<p className={styles.emptyText}>
					No available time slots for this date
				</p>
			</div>
		);
	}

	return (
		<div className={styles.container}>
			{Object.entries(groupedSlots).map(([period, slots]) => {
				if (slots.length === 0) return null;

				return (
					<div key={period} className={styles.periodGroup}>
						<h4 className={styles.periodTitle}>{period}</h4>
						<div className={styles.slotsGrid}>
							{slots.map((slot) => (
								<button
									key={slot}
									type="button"
									onClick={() => onSelectSlot(slot)}
									className={`${styles.slotButton} ${
										selectedSlot === slot ? styles.selected : ""
									}`}
								>
									{formatTime(slot)}
								</button>
							))}
						</div>
					</div>
				);
			})}
		</div>
	);
}
